import { GenerateObservable } from './GenerateObservable';
export var generate = GenerateObservable.create;
//# sourceMappingURL=generate.js.map